export default __webpack_public_path__ + "images/0xc0ba369c8db6eb3924965e5c4fd0b4c1b91e305f.png";